//@flow
import { connect } from 'react-redux';
import DoItLater from './DoItLater';
import { confirmPlan } from '../../../modules/SignUp/actions';

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  onSkipPayment: confirmPlan,
};

export default connect(mapStateToProps, mapDispatchToProps)(DoItLater);
